import State from './State';
import Fetch from './Fetch';
import Filters from './Filters';
import Scores from './Scores';
import Modal from './Modal';

const List = ({
  score,
  mode,
  userFilter,
  logout,
  permissions = [],
  losesAccess = null,
  message = null,
}) => {
  const amount = mode === 'resume' ? 3 : null;
  const fetchAmount = null;
  const editable = permissions.includes(16);

  const state = State();

  const { fetchInteractions } = Fetch({
    score,
    userFilter,
    logout,
    amount: fetchAmount,
    message,
    setInteractions: state.setInteractions,
    setEditedScores: state.setEditedScores,
    setLoading: state.setLoading,
  });

  const filters = Filters({
    interactions: state.interactions,
    query: state.query,
    sortConfig: state.sortConfig,
    setSortConfig: state.setSortConfig,
    mode,
    amount,
    losesAccess,
  });

  const scores = Scores({
    interactions: state.interactions,
    editedScores: state.editedScores,
    setEditedScores: state.setEditedScores,
    setLoadingUpdate: state.setLoadingUpdate,
    fetchInteractions,
    message,
  });

  const modal = Modal({
    losesAccess,
    setOpen: state.setOpen,
  });

  return {
    amount,
    editable,
    ...state,
    ...filters,
    ...scores,
    ...modal,
    fetchInteractions,
  };
};

export default List;
